import { yup } from '@framework/validation/initYup.ts';
import { CiComputedNumberGear } from '../../../../../ui/icons-custom/IconsCustom.tsx';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getDynamicWidgetReference } from '../../../../expressions/references/builder/getDynamicWidgetReference.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema.ts';
import { CommonComputedWidgetConfigComponent } from '../CommonComputedWidgetConfigComponent.tsx';
import { CommonComputedWidgetPreview } from '../CommonComputedWidgetPreview.tsx';
import { type IComputedNumberWidget } from '../IComputedWidget.ts';
import { ComputedNumberConfigSchema } from './ComputedNumberConfigSchema.ts';
import { ComputedNumberWidgetComponent } from './ComputedNumberWidgetComponent.tsx';
import { setComputedNumberTransform } from './setComputedNumberTransform.ts';

export const ComputedNumberWidgetType: IWidgetType<IComputedNumberWidget> = {
  type: WidgetType.ComputedNumber,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  hasValue: true,
  getReference: getDynamicWidgetReference(Datatype.Number),
  name: 'Numero Calcolato',
  icon: <CiComputedNumberGear />,
  rules: [],
  formComponent: ComputedNumberWidgetComponent,
  createFormSchema: ({ widget, parentScope }) => {
    return createCommonFormSchema(
      setComputedNumberTransform(
        widget,
        parentScope,
        yup.number().notRequired(),
      ),
      widget,
    );
  },
  configComponent: CommonComputedWidgetConfigComponent,
  configValidator: ComputedNumberConfigSchema,
  previewComponent: CommonComputedWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
  }),
  alwaysEnabled: true,
};
